<template>
    <div>
        <el-row class="headerTop">
            <el-col :span="3">
                <div class="title">
                    {{this.$store.state.title}}
                </div>
            </el-col>
            <el-col :span="2">
                <div class="">
                    <el-button type="primary" @click="handleChangeDialog">增加企业</el-button>
                </div>
            </el-col>
            <el-col :span="2">
                <div class="">
                    <el-button plain @click="handlecommer">设置标杆企业</el-button>
                </div>
            </el-col>
            <el-col :span="17">
                <div class="">
                    <el-input v-model="input" @blur='handlechangeInput' placeholder="支持企业名称/统一信用代码检索" :style="{width:'500px'}"></el-input>
                    <el-button type="primary" @click="handleSearchInput">搜索</el-button>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="填写企业信息" :visible.sync="modalVisible" width="50%" @close='handleClose'>
            <ticketMessage msg-father="dad无可奉告" v-if="modalVisible"></ticketMessage>
        </el-dialog>
        <el-dialog title="设置标杆企业" :visible.sync="commerVisible" width="30%" >
            <div class='commerBox'>
                <p class="commerP">行业分类</p>
                <el-input v-model="industryinput" placeholder="请输入内容"></el-input>
                <p class="commerP">设置企业</p>
                <el-select
                    v-model="value"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    style="wdith:100%"
                    @change='handlechooseOption'
                    :loading="loading">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </el-dialog>
        <el-row>
            <el-col :span='24'>
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                >
                        <el-table-column
                            type="selection"
                            width="55"
                        >
                        </el-table-column>
                        <el-table-column
                            label="序号"
                            prop="serNum"
                            width="95"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="companyName"
                            label="企业名称"
                            width="285"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="organizationCode"
                            label="统一信用代码"
                            width="215"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="stockCode"
                            label="股票代码"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="stockShortName"
                            label="股票简称"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="industry"
                            label="行业分类"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="survivalStatus"
                            label="存续状态"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="cmpNature"
                            label="企业性质"
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="deleteRow(scope.$index,scope)"
                                type="text"
                                size="small">
                                操作
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="modifyTime"
                            label="最近更新时间"
                        >
                        </el-table-column>
                </el-table>
            </el-col>
            <el-col>
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="pagesize"
                        layout="prev, pager, next, jumper"
                        v-show="showPagination"
                        :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="填写企业信息" :visible.sync="excelVisible" v-if="excelVisible" width="50%" @close='handleClose'>
            <el-row>
                <el-col>
                    <div  class="uploadBox">
                            <div class="uploadItem">
                                    <p class='uploadP'>公司介绍</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFile"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFile"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>十大股东明细</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileTop"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileTop"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>财务摘要</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileMon"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileMon"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>偿债指标</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileTES"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileTES"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>运营能力</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileRng"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileRng"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>发行债券</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileIg"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileIg"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>资产负债表</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileOmg"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileOmg"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>评级信息</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileFpx"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/evalation"
                                        :http-request="uploadFileFpx"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                        </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import ticketMessage from './ticketmessage'
export default {
    components:{
        ticketMessage
    },
    mounted(){
        this.handleChangeindustryinput();
        this.handleajax(this.currentPage);
    },
    data() {
        return {
            currentPage: 1,
            pagesize:10,
            title:'汽车行业',
            total:100,
            id:0,
            value:[],
            options: [],
            list: [],
            loading: false,
            modalVisible:false,
            excelVisible:false,
            commerVisible:false,
            industryinput:'',
            setinput:'',
            input:'',
            tableData: [],
            multipleSelection: [],
            showPagination:true
        }
    },
    computed: {
        isFollow () {
            return this.$store.state.title;　　
        },
        myheader(){
            return {
                "Content-Type":"multipart/form-data"
            }
        }
    },

    watch: {
        isFollow (newVal, oldVal) {
            this.handleChangeindustryinput();
            this.handleajax(this.currentPage);
        }
    },
    methods: {
        //公司介绍
        uploadFile (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpBase',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，上传成功！',
                                    type: 'success',
                                    offset:800
                                });
                            }else{
                                // this.$message(result.data.message);
                                this.$refs.uploadFile.clearFiles()
                                this.$message({
                                    showClose: true,
                                    message: result.data.message,
                                    type: 'success',
                                    offset:800
                                });
                            }
                        }
            )
        },
        //十大股东明细
        uploadFileTop (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpShareholderExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileTop.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //财务摘要
        uploadFileMon (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpFinanceExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileMon.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //偿债指标
        uploadFileTES (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpDebtExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileTES.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //运营能力
        uploadFileRng (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpOperationExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileRng.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //发行债券
        uploadFileIg (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpBond',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileIg.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //资产负债表
        uploadFileOmg (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpBalanceExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileOmg.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //评级信息
        uploadFileFpx (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.id)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/evalation',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileFpx.clearFiles()
                                this.$message(result.message);
                            }
                        }
            )
        },
        handleajax(val){
            this.ajax.post('/shangPiao/getCmpListPage',{bizContent: {currentPage: val.toString(),pageSize:this.pagesize.toString(),industry:this.$store.state.title}})
                .then(
                    result=>{
                    if(result.data.status=='0000'){
                        this.tableData=result.data.data.data;
                        this.total=result.data.data.total;
                    }else{
                        this.$message.error(result.message);
                    }
                    }
                )
        },
        handleChangeindustryinput(){
            this.industryinput=this.$store.state.title;
        },
        handlecommer(){
            this.commerVisible=!this.commerVisible
        },
        handleSearchInput(){
            this.currentPage=1;
            this.ajax.post('/shangPiao/selectLikeOgrOrCmpName',{bizContent: {currentPage: this.currentPage.toString(),pageSize:this.pagesize.toString(),searchKey:this.input,industry:this.$store.state.title}})
                .then(
                    result=>{
                    if(result.data.status=='0000'){
                        this.tableData=result.data.data.data;
                        this.total = result.data.data.total;
                    }
                    }
                )

        },
        handlechangeInput(e){

        },
        handleChangeDialog(){
            this.modalVisible=!this.modalVisible;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        deleteRow(index, scope) {
            this.excelVisible=!this.excelVisible;
            this.id=scope.row.organizationCode
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.handleajax(val);
        },
        remoteMethod(query) {
        if (query !== '') {
            this.loading=true
            this.ajax.post('/shangPiao/getBenchmarkSearch',{bizContent: {industry: this.$store.state.title,searchKey:query}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            result.data.data.data.map(it=>{
                                this.options.push({value:it.companyName,key:it.id});
                                this.loading=false;
                                this.showPagination=true;
                            })
                        }else{
                            ths.showPagination=false;
                        }
                    }
                )
            } else {
                this.options = [];
            }
        },
        handlechooseOption(e){
            this.ajax.post('/shangPiao/setBenchmarkCmp',{bizContent: {companyName: e , industry:this.$store.state.title}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.$message('标杆企业设置成功');
                            this.commerVisible=false;
                            this.options = [];
                        }else{
                            this.$message.error('标杆企业设置失败');
                        }
                    }
                )
        },
        handleBefore(file){
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 10;
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if(!isLt2M){
                this.$message.error('上传模板大小不能超过 10MB');
                return false;
            }
        },
        handleClose(){
            // console.log('33333')
            // this.currentPage = 1;
            // this.handleajax(this.currentPage);
        }
    }
}
</script>
<style scoped>
.headerTop{
    margin-top: 10px;
    margin-bottom: 10px;
}
.title{
    color: #333333FF;
    font-size: 24px;
}
.block{
    margin-top: 20px;
    width: 100%;
    text-align: center;
}
.commerP{
    color: #343C4EFF;
    font-size: 14px;
    margin-bottom: 15px;
    margin-top: 10px;
}
.el-select{
    width: 100%;
}
.uploadBox{
    width: 100%;
}
.uploadItem{
    float: left;
    height: 300px;;
    width: 30%;
    margin-left: 3%;
    margin-bottom: 15px;
}
.uploadP{
    color: #343C4EFF;
    font-size: 14px;
    font-weight: 600;
    margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/page/bussinessticket/ticketlist.vue